module.exports = __webpack_public_path__ + "static/img/SF108WP_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/SF108WP_1.png
// module id = uTy8
// module chunks = 0